import axios from "axios";
import { addPlaceSuggestionToCurationUrl, getCreateCurationUrl, getCurationMembersUrl, getCurationPlaceSuggestionsUrl, getCurationsUrl, getDeleteCurationUrl, getSearchCurationsUrl, getUpdateCurationCoverPhotoUrl, getUpdateCurationUrl, getUserCurationsUrl, getInvitationDetailsUrl, getJoinPublicCurationUrl, generateInvitationLinkUrl, getPublicCurationUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class CurationRepository {
    async getCurations(curationId) {
        const session = await supabase.auth.getSession()
        let response = null
        if (session.data.session == null) {
            console.log("Getting public curation")
            response = await axios.get(
                getPublicCurationUrl(curationId)
            );
        } else {
            response = await axios.get(
                getCurationsUrl(curationId),
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            );
        }
        console.log(response.data)
        return response.data
    }

    async deleteCuration(curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.delete(
            getDeleteCurationUrl(curationId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async getCurationMembers(curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getCurationMembersUrl(curationId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getCurationPlaceSuggestions(curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getCurationPlaceSuggestionsUrl(curationId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async addPlaceSuggestionToCuration(suggestionId, curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            addPlaceSuggestionToCurationUrl(suggestionId, curationId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async joinPublicCuration(curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getJoinPublicCurationUrl(curationId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getUserCurations() {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserCurationsUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getSearchCurations(input) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getSearchCurationsUrl(input),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async createCuration(
        title, description, filters, isPrivate
    ) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getCreateCurationUrl(),
            {
                filters: filters,
                title: title,
                description: description,
                isPrivate: isPrivate
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async updateCuration(
        curationId, title, description, filters, emoji, isPrivate
    ) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getUpdateCurationUrl(curationId),
            {
                filters: filters,
                title: title,
                description: description,
                emoji: emoji,
                isPrivate: isPrivate
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async uploadCoverPicture(curationId, picture) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append(`image`, picture)
        const response = await axios.post(
            getUpdateCurationCoverPhotoUrl(curationId),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async getInvitationDetails(invitationLinkId) {
        // const session = await supabase.auth.getSession()
        const response = await axios.get(
            getInvitationDetailsUrl(invitationLinkId),
            {
                headers: {
                }
            }
        );
        return response.data
    }

    async generateInvitationLink(curationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            generateInvitationLinkUrl(curationId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }
}
